<template>
  <div class="trading-notice">
    <pageHeader title="交易须知" />

    <div class="trading-notice-container">
      <div class="page-nav">
        <div class="page-nav-item" @click="currentIndex = 0">
          <span
            :class="['nav-label', currentIndex == 0 ? 'nav-active-label' : '']"
            >卖家须知</span
          >
          <span v-if="currentIndex == 0" class="underline-box"></span>
        </div>
        <div class="page-nav-item" @click="currentIndex = 1">
          <span
            :class="['nav-label', currentIndex == 1 ? 'nav-active-label' : '']"
            >买家须知</span
          >
          <span v-if="currentIndex == 1" class="underline-box"></span>
        </div>
      </div>

      <div class="gray-box"></div>

      <div class="trade-flow" v-show="currentIndex == 0">
        <div class="flow-step">
          <img src="@/assets/images/step1.png" alt="" />
          <span>提交商品</span>
        </div>
        <img class="step-arrow" src="@/assets/images/step-arrow.png" alt="" />
        <div class="flow-step">
          <img src="@/assets/images/step2.png" alt="" />
          <span>客服审核</span>
        </div>
        <img class="step-arrow" src="@/assets/images/step-arrow.png" alt="" />
        <div class="flow-step">
          <img src="@/assets/images/step3.png" alt="" />
          <span>买家购买</span>
        </div>
        <img class="step-arrow" src="@/assets/images/step-arrow.png" alt="" />
        <div class="flow-step">
          <img src="@/assets/images/step4.png" alt="" />
          <span>验号换绑</span>
        </div>
        <img class="step-arrow" src="@/assets/images/step-arrow.png" alt="" />
        <div class="flow-step">
          <img src="@/assets/images/step5.png" alt="" />
          <span>获得收益</span>
        </div>
      </div>
      <div class="trade-flow trade-flow-buy" v-show="currentIndex == 1">
        <div class="flow-step" style="width: 80px">
          <img src="@/assets/images/step6.png" alt="" />
          <span>拍下商品并支付</span>
        </div>
        <img class="step-arrow" src="@/assets/images/step-arrow.png" alt="" />
        <div class="flow-step" style="width: 70px">
          <img src="@/assets/images/step7.png" alt="" />
          <span>联系客服验号</span>
        </div>
        <img class="step-arrow" src="@/assets/images/step-arrow.png" alt="" />
        <div class="flow-step" style="width: 60px">
          <img src="@/assets/images/step8.png" alt="" />
          <span>换绑手机号</span>
        </div>
        <img class="step-arrow" src="@/assets/images/step-arrow.png" alt="" />
        <div class="flow-step" style="width: 45px">
          <img src="@/assets/images/step9.png" alt="" />
          <span>获得账号</span>
        </div>
      </div>
      <div class="gray-box"></div>
      <div class="trade-desc" v-show="currentIndex == 0">
        1、您仅可出售在该APP账号下，首充过一定金额的游戏账号，且同一商品只能出售一次；<br/>
        2、提交商品后，客服会在24小时内审核，您也可以联系平台客服加急审核；<br/>
        3、出售期间，客服可能会登录您的游戏账号，以获取最新的游戏信息；<br/>
        4、为保障您的账号安全，切勿把账号密码发给除官方客服以外的人员；<br/>
        5、当有买家购买您的账号后，需要双方同时在线，换绑手机号，以完成交易；<br/>
        6、交易完成后，收益会以余额形式发放到您的APP账户，期间需要扣除5%手续费；<br/>
        <em style="font-weight: 600">7、账号交易会将您的游戏账号、该账号下的全部小号和角色，全部交易给买家，交易成功后不支持撤销，出售前请慎重考虑；</em>
        
      </div>
      <div class="trade-desc" v-show="currentIndex == 1">
        1、购买商品后，请尽快联系平台客服进行交易；<br/>
        2、验号阶段，可以要求客服提供游戏内最新截图，如果对账号不满意，可无条件退款；<br/>
        3、确认购买后，客服会联系买卖双方换绑手机号，以完成交易；<br/>
        4、交易成功后，您将获得该账号，请立刻修改账号密码，若因未修改密码、泄露密码，导致的损失需要您自行承担；<br/>
        5、交易成功后，不支持退货；
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.trading-notice {
  .trading-notice-container {
    .page-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px;

      .page-nav-item {
        width: 335px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        position: relative;
        .nav-label {
          display: block;
          position: relative;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #333333;
        }
        .nav-active-label {
          font-weight: 600;
          font-size: 36px;
          color: #333333;
          z-index: 2;
        }
        .underline-box {
          position: absolute;
          left: 110px;
          top: 50px;
          width: 116px;
          height: 14px;
          background: linear-gradient(149deg, #ff957f 0%, #ffc8b2 99%);
          border-radius: 7px;
        }
      }
    }

    .gray-box {
      width: 100%;
      height: 20px;
      background: #f7f8fa;
    }

    .trade-flow {
      padding: 20px 55px 30px 55px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .flow-step,
      .flow-step-buy {
        width: 90px;
        text-align: center;

        img {
          width: 80px;
          height: 80px;
          margin-bottom: 10px;
        }
        span {
          display: block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #414141;
          line-height: 30px;
        }
      }

      .step-arrow {
        width: 28px;
        height: 30px;
        margin-top: -40px;
      }
    }
    .trade-flow-buy {
      padding: 20px 28px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .trade-desc {
      padding: 20px 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #414141;
      line-height: 40px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/tradingNotice/index.vue